import React, { useState, useEffect } from 'react'
import { Select, Form } from "antd";
import toast from "react-hot-toast";
import ModalComponent from "../../../components/global/modal/ModalComponent";
import { UpdateIBApi } from "../../../api/request/client"
import { GetAllibApi } from "../../../api/request/ibapproved.js";
import LoadableButton from "../../../components/buttons/LoadableButton.jsx";

function UpdateIB({ isOpenIBModal, setisOpenIBModal, id, ib, onUpdated }) {

    const [form] = Form.useForm();
    const [initialValues, setInitialValues] = useState()
    const [isLoading, setIsLoading] = useState(false);
    const [isUsersLoading, setIsUsersLoading] = useState(false);
    const [users, setUsers] = useState([]);

    const getUsers = async () => {
        try {
            setIsUsersLoading(true);
            const params = {
                FilterText: "Approved",
                ApplyPagination: false,
                SortBy: "Name",
                SortOrder: "ascend"
            };
            const { data } = await GetAllibApi(new URLSearchParams(params).toString());
            if (data?.success) {
                const options = (data?.data || [])
                    .filter((item) => item?.userId && item.userId !== id)
                    .map((item) => {
                        const name = (item?.name || `${item?.firstName || ""} ${item?.lastName || ""}`).trim();
                        const email = (item?.email || "").trim();
                        return {
                            value: item.userId,
                            name,
                            email,
                            label: email ? `${name} (${email})` : name
                        };
                    })
                    .sort((a, b) => a.label.localeCompare(b.label));
                setUsers(options);
            }
        } catch (error) {
            toast.error(error?.response?.data?.error?.message || "Unable to load IB users.");
        } finally {
            setIsUsersLoading(false);
        }
    }

    useEffect(() => {
        if (isOpenIBModal) {
            getUsers();
        }
    }, [isOpenIBModal]);

    const handleSubmit = async (values) => {
        try {
            setIsLoading(true)
            let params = {
                IsIB: ib === "No" ? false : true,
                NewIBUserId: values?.userId,
                userId: id
            };
            const { data } = await UpdateIBApi(new URLSearchParams(params).toString());
            if (data?.success) {
                toast.success(data?.message);
                setisOpenIBModal(false)
                form.resetFields();
                onUpdated?.();
            } else {
                toast.error(data?.message || 'Unable to update the parent.');
            }
            setIsLoading(false)
        } catch (error) {
            if (error?.response?.data?.error?.message) {
                toast.error(error?.response?.data?.error?.message);
            }
            setIsLoading(false)
        }
    };
    return (
        <div>
            <ModalComponent isOpen={isOpenIBModal} setIsOpen={setisOpenIBModal} title="IB update" width={720}>
                <Form className='w-full' autoComplete="off" form={form} initialValues={initialValues} onFinish={handleSubmit}>
                    <div className="ant-multi-select-selector ant-select-selector-white">
                        <label className="text-description text-[#2F2B3DCC] font-medium">IB User</label>
                        <Form.Item name="userId" rules={[{ required: true, message: 'Please select a user.' }]}>
                            <Select
                                className="w-full mt-2"
                                showSearch
                                loading={isUsersLoading}
                                placeholder="Search by name or email"
                                options={users}
                                optionFilterProp="label"
                                popupMatchSelectWidth
                                filterOption={(input, option) => {
                                    const query = input.toLowerCase().trim();
                                    if (!query) return true;
                                    const name = (option?.name || "").toLowerCase();
                                    const email = (option?.email || "").toLowerCase();
                                    const label = (option?.label || "").toLowerCase();
                                    return name.includes(query) || email.includes(query) || label.includes(query);
                                }}
                                onSelect={() => {
                                    document.activeElement.blur();
                                }}
                            />
                        </Form.Item>
                    </div>
                    <div className="flex justify-between items-center gap-5 flex-wrap mt-6">
                        <button type='button' onClick={() => setisOpenIBModal(false)} className='bg-primary text-description text-white font-semibold rounded-lg px-4 py-1 capitalize themeHover duration-500'>Cancel</button>
                        <LoadableButton
                            type='submit' className='bg-primary text-description text-white font-semibold rounded-lg px-4 py-1 capitalize themeHover duration-500'
                            disabled={isLoading}
                            lable="Submit"
                            isLoading={isLoading}
                            loadingLable="Update IB..."
                        />
                    </div>
                </Form>
            </ModalComponent>
        </div>
    )
}

export default UpdateIB
